import React from 'react'
import { Container } from 'react-bootstrap'
import Slider from 'react-slick'
import CardLogo from './CardLogo'

import { Background } from './styles'

const setting = {
  dots: false,
  arrows: false,
  className: 'center',
  infinite: true,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 414,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
}

const CardLogos = () => {
  return (
    <Background>
      <Container>
        <Slider {...setting}>
          <CardLogo src="/images/logo-dakar.png" />
          <CardLogo src="/images/logo-quito-andar.png" />
          <CardLogo src="/images/logo-sertoes.png" />
          <CardLogo src="/images/logo-dakar.png" />
          <CardLogo src="/images/logo-quito-andar.png" />
          <CardLogo src="/images/logo-sertoes.png" />
          <CardLogo src="/images/logo-dakar.png" />
          <CardLogo src="/images/logo-quito-andar.png" />
          <CardLogo src="/images/logo-sertoes.png" />
          <CardLogo src="/images/logo-dakar.png" />
          <CardLogo src="/images/logo-quito-andar.png" />
          <CardLogo src="/images/logo-sertoes.png" />
        </Slider>
      </Container>
    </Background>
  )
}

export default CardLogos

{
  /* <img src="/image/logo-quito-andar.png" alt="logo parceiros" />
<img src="/image/logo-sertoes.png" alt="logo parceiros" />
<img src="/image/logo-quito-andar.png" alt="logo parceiros" />
<img src="/image/logo-sertoes.png" alt="logo parceiros" />
<img src="/image/logo-dakar.png" alt="logo parceiros" />
<img src="/image/logo-quito-andar.png" alt="logo parceiros" />
<img src="/image/logo-sertoes.png" alt="logo parceiros" />
<img src="/image/logo-quito-andar.png" alt="logo parceiros" />
<img src="/image/logo-sertoes.png" alt="logo parceiros" /> */
}
